import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const shimmerStyle = {
  background: 'linear-gradient(90deg, #f0f2f7 25%, #e2e6ef 50%, #f0f2f7 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.4s infinite',
  borderRadius: '4px',
};

const TrendChart = ({ data, loading = false }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (loading || !data || !canvasRef.current) return;

    const existing = Chart.getChart(canvasRef.current);
    if (existing) existing.destroy();

    const chart = new Chart(canvasRef.current, {
      type: 'line',
      data: data,
      options: {
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: {
            position: 'bottom',
            labels: { font: { size: 11 }, boxWidth: 10, padding: 10 },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            stacked: true,
            ticks: {
              font: { size: 10 },
              callback: (v) => '$' + v,
            },
            grid: { color: '#eef1f7' },
          },
          x: {
            ticks: {
              font: { size: 9 },
              autoSkip: true,
              maxRotation: 0,
            },
            grid: { display: false },
          },
        },
      },
    });

    return () => chart.destroy();
  }, [data, loading]);

  if (loading) {
    return (
      <div className="chart-wrap-sm" style={{ display: 'flex', alignItems: 'flex-end', gap: '3px', padding: '10px 0' }}>
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
            <div style={{ ...shimmerStyle, width: '100%', height: `${[60, 80, 45, 90, 55, 70, 40, 75, 50, 65][i]}%` }} />
            <div style={{ ...shimmerStyle, width: '80%', height: '8px' }} />
          </div>
        ))}
      </div>
    );
  }

  if (!data) {
    return (
      <div className="chart-wrap-sm" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--muted)', fontSize: '12px' }}>
        No data available
      </div>
    );
  }

  return (
    <div className="chart-wrap-sm">
      <canvas ref={canvasRef}></canvas>
    </div>
  );
};

export default TrendChart;
